"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRef = void 0;
var esdm_gridreference_1 = require("esdm-gridreference");
var olProj = require("ol/proj");
var GridRef = /** @class */ (function () {
    function GridRef(_map, _textPack, _logger, _btnCssClass, _iconCssClass, _clearerCssClass) {
        if (_btnCssClass === void 0) { _btnCssClass = "btn btn-primary"; }
        if (_iconCssClass === void 0) { _iconCssClass = "fa fa-search"; }
        if (_clearerCssClass === void 0) { _clearerCssClass = "fa fa-times"; }
        var _this = this;
        this._map = _map;
        this._textPack = _textPack;
        this._logger = _logger;
        this._btnCssClass = _btnCssClass;
        this._iconCssClass = _iconCssClass;
        this._clearerCssClass = _clearerCssClass;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this._logger.log("Initialising GridRef");
                _this._element = $("#gridref");
                _this.initHtml();
                _this._input = $("#gridRefInput");
                _this._noResults = $("#invalidGridRef");
                _this.addHandlers();
                _this.initContextMenu();
                _this._initialised = true;
            }
        };
        this.initContextMenu = function () {
            var items = [
                '-', // this is a separator
                {
                    text: "<i class=\"fa fa-street-view\" aria-hidden=\"true\"></i>".concat(_this._textPack.getGridReference),
                    callback: _this.onGetGridReferenceClick
                }
            ];
            _this._map.contextMenu.addItems(items);
        };
        this.onGetGridReferenceClick = function (event, map) {
            //Logger.log("onGetGridReferenceClick");
            if (!$("#slide-panel-search").is(':visible')) {
                $("#slide-panel-btn-search").trigger("click");
            }
            $("#gridRefInput").trigger("focus");
            $("#gridRefInput").val(_this.getGridRef(event.coordinate));
        };
        this.initHtml = function () {
            var gridRefHtml = "\n                <div class=\"row gx-2 has-feedback\">\n                    <div class=\"input-group\">\n                        <label class=\"visually-hidden\" for=\"gridRefInput\">".concat(_this._textPack.gridReference, "</label>\n                        <input id=\"gridRefInput\" type=\"text\" spellcheck=\"false\" class=\"form-control hasclear\"  autocomplete=\"off\" placeholder=\"").concat(_this._textPack.gridReference, "\" />\n                        <span class=\"clearer form-control-feedback\"><i class=\"").concat(_this._clearerCssClass, "\" aria-hidden=\"true\"></i></span>\n                        <button id=\"btnSearchGridRef\" class=\"").concat(_this._btnCssClass, "\" aria-label=\"").concat(_this._textPack.gridReference, "\"><i class=\"").concat(_this._iconCssClass, "\" aria-hidden=\"true\"></i></button>                        \n                    </div>\n                </div>       \n\n                <div class=\"mb-2\">                                      \n                    <span id=\"invalidGridRef\" style=\"display:none\"></span>\n                </div>\n         ");
            _this._element.append(gridRefHtml);
        };
        this.addHandlers = function () {
            var self = _this;
            //setup the clearer on the input textbox
            $(".hasclear").on("keyup", function () {
                var t = $(this);
                t.next('span').toggle(Boolean(t.val()));
            });
            $(".clearer").hide(function () {
                $(this).prev('input').val();
            });
            $(".clearer").on("click", function () {
                $(this).prev('input').val('').trigger("focus");
                $(this).hide();
                self._noResults.hide();
            });
            //set the input click and enter key press handlers
            self._input.on("keypress", function (e) {
                if (e.key === "Enter") {
                    self.findGridRef(self._input.val());
                }
            });
            self._input.nextAll("#btnSearchGridRef").on("click", function () {
                self.findGridRef(self._input.val());
            });
        };
        this.findGridRef = function (searchTerm) {
            _this._noResults.hide();
            //remove leading/trailing spaces
            searchTerm = searchTerm.trim();
            var char, sheet, easting = null, northing = null, eastingStr = "", northingStr = "", processNorthing, errorMsg, coordLen, coords, isValid = true;
            // use first two chars as sheet
            sheet = searchTerm.substring(0, 2);
            var patternCheckForTwoLetters = new RegExp("[A-Za-z]{2}");
            if (patternCheckForTwoLetters.test(sheet)) {
                sheet = sheet.toUpperCase();
                //we have a sheet number, so the x/y coords must have the same number of digits
                //remove all spaces
                coords = searchTerm.replace(/\s/g, '').substring(2);
                if (coords.length >= 4 && (coords.length % 2 == 0)) {
                    //we have an even number
                    coordLen = coords.length / 2;
                    easting = parseFloat(coords.substring(0, coordLen));
                    northing = parseFloat(coords.substring(coordLen));
                    //test that coords are both numbers
                    if (isNaN(easting) || isNaN(northing)) {
                        //not both numbers
                        isValid = false;
                    }
                    //all ok we sholud have a sheet number and two coords
                    eastingStr = coords.substring(0, coordLen);
                    northingStr = coords.substring(coordLen);
                }
                else {
                    //not an even number
                    isValid = false;
                }
            }
            else {
                //no sheet number, parse the string one character at time use the first non numeric as the seperator
                sheet = null;
                coords = searchTerm;
                for (var i = 0; i < coords.length; i++) {
                    char = String.fromCharCode(coords.charCodeAt(i));
                    if (!isNaN(parseInt(char))) {
                        //char is a number
                        if (!processNorthing) {
                            //easting
                            eastingStr += char;
                        }
                        else {
                            //northing
                            northingStr += char;
                        }
                    }
                    else {
                        //char is not a number, so we treat as a seperator, unless we already have a value in the northing in which case this is an error
                        if (northing !== null) {
                            isValid = false;
                            break;
                        }
                        else {
                            processNorthing = true;
                        }
                    }
                }
                if (isValid && eastingStr.length !== northingStr.length) {
                    isValid = false;
                }
            }
            if (isValid) {
                _this.centreOnGridRef(sheet, eastingStr, northingStr);
            }
            else {
                _this.showError(_this._textPack.enterAValidGridReference);
            }
        };
        this.centreOnGridRef = function (sheet_number, easting, northing) {
            var gridRef;
            if (sheet_number && easting && northing) {
                //get entered E & N values
                var E = easting;
                var N = northing;
                //E & N must have same no. of chars
                var ELen = easting.length;
                var NLen = northing.length;
                if (ELen != NLen) {
                    //error
                }
                else {
                    //pad to five char with zeros on right
                    for (var i = 0; i < (5 - ELen); i++) {
                        E = E + '0';
                        N = N + '0';
                    }
                    var osgb = new esdm_gridreference_1.OSGB();
                    gridRef = sheet_number + easting + northing;
                    if (osgb.ParseGridRef(gridRef) === true) {
                        _this.moveTo(osgb.Eastings, osgb.Northings);
                    }
                    else {
                        _this.showError(_this._textPack.enterAValidGridReference);
                    }
                }
            }
            else if (!sheet_number && easting && northing) {
                //no sheet number just a coordinate pair
                _this.moveTo(parseFloat(easting), parseFloat(northing));
            }
        };
        this.getGridRef = function (coordinate) {
            var lonlat = olProj.transform(coordinate, _this._map.getDisplayProjection().getCode(), 'EPSG:4326');
            var wgs84 = new esdm_gridreference_1.WGS84(lonlat[1], lonlat[0]);
            //wgs84.GetOSGB().LogGridRef();        
            return wgs84.GetOSGB().GetGridRef(4);
        };
        this.showError = function (msg) {
            _this._noResults.html(msg);
            _this._noResults.show();
        };
        this.moveTo = function (easting, northing) {
            if (_this._map.olMap.getView().getProjection().getCode() !== 'EPSG:27700') {
                var coord = olProj.transform([easting, northing], 'EPSG:27700', _this._map.olMap.getView().getProjection().getCode());
                easting = coord[0];
                northing = coord[1];
            }
            _this._map.olMap.getView().animate({ center: [easting, northing] });
            _this._map.contextMenu.addMarker([easting, northing]);
        };
        this.init();
    }
    return GridRef;
}());
exports.GridRef = GridRef;
//# sourceMappingURL=GridRef.js.map